//#region directives/focustrap_directive/focustrap_utils.js
var e = ":not(:disabled):not([aria-disabled=\"true\"]):not([role=\"presentation\"])", t = `${e}:not([tabindex="-1"])`, n = "button,[href],input,select,textarea,details,[tabindex]";
function r(r, { includeNegativeTabIndex: i = !1 } = {}) {
	if (!r) return [];
	let a = [...r.querySelectorAll(n)], o = i ? e : t;
	return a.filter((e) => {
		let t = window.getComputedStyle(e);
		return t.getPropertyValue("display") !== "none" && t.getPropertyValue("visibility") !== "hidden" && e.matches(o);
	});
}
function i(e) {
	if (!e.length) return;
	let t = e[0];
	return t.matches("[type=\"radio\"]:not(:checked)") && t.name && e.find((e) => e.checked && e.name === t.name) || t;
}
//#endregion
export { i as getFirstFocusCandidate, r as getTabbableElements };

//# sourceMappingURL=focustrap-utils.js.map